var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Bilde',{attrs:{"value":_vm.data,"variables":_vm.variables}})}
var staticRenderFns = []

export { render, staticRenderFns }